export var OfferingLocationType;
(function (OfferingLocationType) {
    OfferingLocationType["CUSTOMER"] = "CUSTOMER";
    OfferingLocationType["BUSINESS"] = "BUSINESS";
    OfferingLocationType["OTHER"] = "OTHER";
})(OfferingLocationType || (OfferingLocationType = {}));
//# sourceMappingURL=offering-location.dto.js.map